module.exports = __webpack_public_path__ + "static/Macbook@3x-c5257e1e95421aef57ec879fbd479a35.png";